import React, {useEffect, useState} from "react"
import {Form} from "react-bootstrap"
import {Controller, useForm} from "react-hook-form";
import {useNavigate} from "react-router";
import {notification} from "antd";
import ThemeButton from "../../../components/common/theme-button/ThemeButton";
import DescriptionField from "../../../components/common/description-field/DescriptionField";
import {CloseRoundedCheck, RoundedCheck} from "../../../../assets/icons/defaultIcons";
import {checkEmptySpaces, maxLength, Required} from "../../../utils/patterns";
import {AddAnnualBook} from "../../../services/target-api.service";


export default function AddAnnualBooks({close, setUpdateGoals , updateGoals, year}) {
    const[loader,setLoader] = useState(false);
    const[question,setQuestion] = useState(false);

    const {
        handleSubmit,
        reset,
        formState: {errors, isValid},
        control,
        setValue,
        watch
    } = useForm({
        mode: 'onChange',
    })
    const navigate = useNavigate()

    const questionPayload = {
        category: 'gratitude',
    }


    const onSubmit = async (data) => {
        setLoader(true)

        if(data){
            let payload = {
                title:data.des,
                year: year
            }

            const response = await AddAnnualBook(payload)

            if (response?.data?.data?.status){
                notification.success({
                    message: "Success",
                    description: "Book added Successfully",
                    placement: "topRight",
                    icon: <RoundedCheck/>,
                    duration: 2,
                });
                setLoader(false)
                setUpdateGoals(!updateGoals)
                reset()
                close(false)
            }
            else{
                setLoader(false)
                notification.error({
                    message: "Failed",
                    description: "Book Failed to Add",
                    placement: "topRight",
                    icon: <CloseRoundedCheck/>,
                    duration: 2,
                });
            }

        }

    }

    const categorySelect = [
        { value: "Faith", label: "Faith" },
        { value: "Family", label: "Family" },
        { value: "Fitness", label: "Fitness" },
        { value: "Finance", label: "Finance" },
        { value: "Others", label: "Others" },
        { value: "Books", label: "Books" }
    ];

    const hello = watch("category")

    useEffect(()=>{
        console.log(hello, 'hello')
    },[hello])


    return(
        <div className={'add-gratitude'}>
            <Form onSubmit={handleSubmit(onSubmit)}>
                <div className={'dfields'}>
                    <Controller
                        name="des"
                        defaultValue={''}
                        control={control}
                        rules={{required:Required, maxLength: maxLength(2000) , validate:checkEmptySpaces}}
                        render={({field: {name, ...field}}) => (
                            <DescriptionField
                                placeholder={'Write your book name here'}
                                type={'text'}
                                defaultValue={field.value}
                                field={field}
                                errors={errors.des}
                                autoSize={{ minRows: 12, maxRows: 12 }}
                                label={'Write your Book Name '}
                            />
                        )}
                    />
                </div>
                <div className={'mt-30'}>
                    <ThemeButton
                        text={'Submit'}
                        type={'submit'}
                        className={'btn-light-lg'}
                        loader={loader}
                    />
                </div>
            </Form>
        </div>
    )
}